export const TOGGLE = 'TOGGLE';

export default {
  TOGGLE,
};
